import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import Downshift from 'downshift';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl } from 'react-intl';
import { withRtl } from '../hoc';
import messages from '../../locale/messages';
import analytics from '../../services/analytics';

import SearchIcon from '../icons/Search';
import style from './SearchField.scss';
import CloseIcon from '../../components/icons/Close';
import _ from 'lodash';
import {customisedIntlFormatMessage} from '../../utils/helpers';

class SearchField extends Component {
  static propTypes = {
    autocomplete: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChangeValue: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    onSearch: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    placeholder: PropTypes.shape({}),
    isMobile: PropTypes.bool,
    user: PropTypes.shape().isRequired,
    display: PropTypes.string,
  };
  // static contextTypes = {
  //   intl: PropTypes.shape().isRequired,
  // };
  static defaultProps = {
    autocomplete: false,
    onChangeValue: false,
    placeholder: {
      id: 'searchfield.input.placeholder',
      defaultMessage: 'Search for a program to add',
      description: 'Search placeholder',
    },
    isMobile: false,
    display: ''
  };

  constructor(props) {
    super(props);

    // used to remember which destination was hovered last,
    // so the state is changed only when the first hover is triggered
    this.state = {
      searchText: this.props.display,
    };
  }

  setSearchText = (event, searchText) => {
    const { autocomplete } = this.props;
    this.setState({ searchText });
    if (event.key === 'Enter') {
      this.submitSearch();
    } else if (autocomplete) {
      this.props.onChangeValue(searchText);
    }
  };

  submitSearch = () => {
    const { searchText } = this.state;
    this.props.onSearch({ optionGroups: { search: [searchText] } });
    if (searchText) {
      analytics({
        eventLabel: 'keywordSearch',
        dataDictionary: {
          searchText,
          loggedIn: this.props.user.applicationId ? true : false
        },
      });
      
    }
  };

  handleSelect = item => {
    const { onClick } = this.props;
    this.setState({ searchText: item });
    onClick(item);
  };

  handleClear = () => {
    this.setState({ searchText: '' }, ()=>{
      this.submitSearch();
    });
  };

  debounce = (callback, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => callback(...args), delay);
    };
  };

  handleOnChange = event => {
    const { autocomplete } = this.props;
    if (event.target.value === '') {
      this.setState({ searchText: '' }, () => {
        if (autocomplete) {
          _.debounce(() => this.props.onChangeValue(''), 250);
        } else {
          _.debounce(() => this.submitSearch(), 250);
        }
      });
    }
  };

  BasicAutocomplete = (items, autocomplete) => {
    const { placeholder, isMobile } = this.props;
    const { intl } = this.props;
    const { setSearchText } = this;
    const { searchText } = this.state;
    const buttonClasses = [style.button];
    const clearSearchButton =[style.clearSearchButton];
    const clearSearch = [style.clearSearch];
    if (isMobile) {
      buttonClasses.push(style.buttonIsMobile);
    }
    /* eslint-disable no-unused-vars */
    if (autocomplete) {
      const { mouseUp, touchStart, blurInput } = Downshift.stateChangeTypes;
      // --with-downshift
      return (
        <div className='exclude-print'>
          <Downshift
            inputValue={this.state.searchText}
            onSelect={item => this.handleSelect(item)}
            onStateChange={changes => {
              // possible events fired when clicked outside of component

              if (
                changes.type !== mouseUp &&
                changes.type !== touchStart &&
                changes.type !== blurInput &&
                changes.inputValue !== undefined
              ) {
                this.setState({ searchText: changes.inputValue });
              }
            }}
          >
            {({ getRootProps, getInputProps, getItemProps, isOpen, inputValue, highlightedIndex, openMenu }) => {
              const searchfieldClasses = [style.input];
              if (isOpen && items.length) {
                searchfieldClasses.push(style.inputWithDownshift);
                buttonClasses.push(style.buttonWithDownshift);
              }

              return (
                <div className={style.root} {...getRootProps({'aria-labelledby': undefined})}>
                  <input
                    type="text"
                    className={classNames(...searchfieldClasses)}
                    aria-label={customisedIntlFormatMessage(intl, messages.generalStringSearch)}
                    {...getInputProps({
                      placeholder: customisedIntlFormatMessage(intl, placeholder),
                      onKeyUp: event => {
                        setSearchText(event, inputValue);
                      },
                      onFocus: () => inputValue && openMenu(),
                      onChange: this.handleOnChange,
                      'aria-labelledby': undefined,
                    })}
                  />
                  {searchText && (
                    <div className={classNames(...clearSearch)}>
                      <CloseIcon
                          size={12}
                          fill="#024cbc"
                          className={classNames(...clearSearchButton)}
                          onClick={this.handleClear}
                          aria-label={customisedIntlFormatMessage(intl, messages.buttonClearSearch)}
                      />
                    </div>
                  )}
                  <button
                    className={classNames(...buttonClasses)}
                    onClick={this.submitSearch}
                    aria-label={customisedIntlFormatMessage(intl, messages.buttonSearch)}
                  >
                    <SearchIcon size={25} fill={isMobile ? '#024cbc' : '#fff'} />
                  </button>
                  {isOpen && items.length ? (
                    <div className={style.autocompleteItemsContainer}>
                      {items.map((item, index) => {
                        const autocompleteItemClasses = [style.autocompleteItem];
                        if (index === highlightedIndex) {
                          autocompleteItemClasses.push(style.focus);
                        }
                        return (
                          <div
                            {...getItemProps({
                              item,
                              index,
                            })}
                            key={item}
                            className={classNames(...autocompleteItemClasses)}
                          >
                            {item}
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              );
            }}
          </Downshift>
        </div>
      );
    }
    return (
      <div className={style.root}>
        <input
          className={style.input}
          type="text"
          placeholder={customisedIntlFormatMessage(intl, placeholder)}
          onKeyUp={event => {
            this.setSearchText(event, event.target.value);
          }}
          aria-label={customisedIntlFormatMessage(intl, messages.generalStringSearch)}
          onChange={this.handleOnChange}
          defaultValue={this.state.searchText}
        />
        {searchText && (
          <div className={classNames(...clearSearch)}>
            <CloseIconCloseIcon
              size={12}
              fill="#024cbc"
              className={classNames(...clearSearchButton)}
              onClick={this.handleClear}
              aria-label={customisedIntlFormatMessage(intl, messages.buttonClearSearch)}
              />
          </div>
        )}
        <button
          className={classNames(...buttonClasses)}
          aria-label={customisedIntlFormatMessage(intl, messages.buttonSearch)}
          onClick={this.submitSearch}
        >
          <SearchIcon size={25} fill={isMobile ? '#024cbc' : '#fff'} />
        </button>
      </div>
    );
  };

  render() {
    const { autocomplete, items } = this.props;
    return this.BasicAutocomplete(items, autocomplete);
  }
}

export { SearchField };
export default withRtl(style)(withStyles(style)(injectIntl(SearchField)));
